import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedTrackingModule} from '../../../app-common/shared-tracking.module';
import {Router} from '@angular/router';
import {TimeslotDetails} from '../../../types/TimeslotDetails';
import {QueryParams} from '../../../types/QueryParams';

@Component({
  standalone: true,
  imports: [CommonModule, SharedTrackingModule],
  selector: 'app-timeslot-button',
  templateUrl: './timeslot-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: '',
  },
})
export class TimeslotButtonComponent {
  timeslot = input<TimeslotDetails>(null);

  constructor(private readonly router: Router) {}

  protected navigateToBookingUrl(routerLink: string[], queryParams: QueryParams): void {
    this.router.navigate(routerLink, {queryParams: queryParams});
  }
}
